import { differenceInMinutes, getMilitaryTime } from '../../lib/date';

const getFlightDateTime = ({ date, time }) => {
  const { hour, minute } = getMilitaryTime(time);

  const dateTime = new Date(date);
  dateTime.setHours(hour);
  dateTime.setMinutes(minute);

  return dateTime;
};

export const getTransitDuration = (inbound, outbound) => {
  const arrival = getFlightDateTime(inbound.arrival);
  const departure = getFlightDateTime(outbound.departure);
  const layoverMinutes = differenceInMinutes(departure, arrival);
  return {
    hour: Math.floor(layoverMinutes / 60),
    minute: layoverMinutes % 60,
  };
};

const mapDurationFromFlights = (flights) =>
  flights.reduce(
    (previousValue, currentValue, i) => {
      const duration = getMilitaryTime(currentValue.duration);
      const transitDuration = flights[i + 1]
        ? getTransitDuration(currentValue, flights[i + 1])
        : {
            hour: 0,
            minute: 0,
          };

      const totalMinutes =
        previousValue.minute + duration.minute + transitDuration.minute;
      const totalHours =
        previousValue.hour + duration.hour + transitDuration.hour;

      const hour = totalHours + Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;

      return {
        hour,
        minute,
      };
    },
    {
      hour: 0,
      minute: 0,
    },
  );

export default mapDurationFromFlights;
